$('.engineering-works__title-more').click(function(){
    $(this).text(function(i, v){
        return v === 'Подробнее' ? 'Скрыть' : 'Подробнее'
    });

    $('.engineering-works__content').slideToggle();
});
